import React, { Component } from 'react'
import { connect } from 'react-redux'

import Icon from 'components/icon/icon'

import TaskName from './task-name'
import TaskPeople from './task-people'
import TaskStatus from './task-status'
import TaskDates from './task-dates'
import TaskTimer from './task-timer'
import TaskEstimate from './task-estimate'
import TaskText from './task-text'
import TaskProject from './task-project'

import SingleTaskPortal from '../single-task/single-task-portal'

import Onboarder from 'components/onboarder/onboarder'

import {
	createTodo,
	openModal,
} from 'state/actions'

import {
	randomTaskName,
	getPrimaryColumnValue,
} from 'utils'

import isEqual from 'react-fast-compare'

import {
	isMobile,
	isTaskInTodos,
} from 'utils'

import { forIn } from 'lodash'

class Task extends Component {
	state = {
		hasMounted: false,
		elementHeight: 36,
		isForcedFocus: false,
		isSingleVisibleInModal: false
	}

	randomString = randomTaskName()
	ref = null

	componentDidMount = _ => {
		setTimeout(_ => {
			if (this.props.task && this.ref) {
				this.props.addTaskRef(this.props.task, this.ref)

				// don't actually hide the task until it's been visible for 1 second (fixes toggle milestone stuff)
				this.setState({
					elementHeight: 39
				})
			}
		}, 1)

		if (!this.props.loading) {
			setTimeout(_ => {
				this.setState({
					hasMounted: true
				})
			}, 1000)
		}

		this.isMobile = isMobile()
	}

	componentDidUpdate = (prevProps, prevState) => {
		setTimeout(_ => {
			if (!this.ref) {
				return
			}

			if (this.props.task && (!prevProps.task || prevProps.task.id == -1)) {
				this.props.addTaskRef(this.props.task, this.ref)
			}

			if (this.isMobile) {
				const newHeight = this.ref.getBoundingClientRect().height

				if (this.state.elementHeight !== newHeight) {
					this.props.addTaskRef(this.props.task, this.ref)

					this.setState({
						elementHeight: newHeight
					})
				}
			}
		}, 1)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		const {
			task,
			currentEditedTask,
			menuState
		} = this.props

		if (!task) {
			return false
		}

		// Some simple checks, before we use fast-compare.
		const isOrWasTaskBeingEdited = (currentEditedTask || nextProps.currentEditedTask)

		if (isOrWasTaskBeingEdited) {
			const isOrWasThisTask = currentEditedTask === task.id || nextProps.currentEditedTask === task.id

			if (!isOrWasThisTask) {
				return false
			}
		}

		const isOrWasTaskFocused = (menuState.currentFocusedTask || nextProps.menuState.currentFocusedTask)

		if (isOrWasTaskFocused) {
			const isOrWasThisTask = menuState.currentFocusedTask === task.id || nextProps.menuState.currentFocusedTask === task.id

			if (!isOrWasThisTask) {
				const newTask = nextProps.task

				if (task && newTask && task.updated_at === newTask.updated_at) {
					return false
				}
			}
		}

		// Fast-compare, ignoring some functions and stuff
		const oldProps = {}
		const newProps = {}

		const keysToIgnore = [
			'addTaskRef',
			'clearTaskActivityHistory',
			'editTaskName',
			'openMenu',
			'taskIndex',
			'allTodos',
			'allTodoDays',
			'addTaskOffset',
			'createTodo',
			'currentProject',
			'parentProject',
			'setBrainData',
			'openModal',
			'milestone',
			'taskUpdateCallback'
		]

		const idOnlyKeys = [
			'applicableUsers',
			'normalisedApplicableUsers'
		]

		forIn(this.props, (value, key) => {
			if (!~keysToIgnore.indexOf(key)) {
				oldProps[key] = value
			}

			if (~idOnlyKeys.indexOf(key)) {
				const filteredValue = (value && value.length) ? value.filter(Boolean) : []
				oldProps[key] = filteredValue.map(item => item.id)
			}
		})

		forIn(nextProps, (value, key) => {
			if (!~keysToIgnore.indexOf(key)) {
				newProps[key] = value
			}

			if (~idOnlyKeys.indexOf(key)) {
				const filteredValue = (value && value.length) ? value.filter(Boolean) : []

				newProps[key] = filteredValue.map(item => item.id)
			}
		})

		const arePropsEqual = isEqual(oldProps, newProps)
		const isStateEqual = isEqual(this.state, nextState)

		if (arePropsEqual && isStateEqual) {
			return false
		}

		return true
	}

	addTaskToTodos = _ => {
		const {
			task,
			createTodo
		} = this.props

		createTodo(null, null, _ => { }, task.id)
	}

	deleteTask = _ => {
		const {
			task,
			openModal
		} = this.props

		openModal('delete', 'task', { data: task })
	}

	editMobileTaskName = _ => {
		const {
			task,
			openModal
		} = this.props

		openModal('edit', 'task', task)
	}

	forceSetCurrentFocusedTask = id => {
		const {
			forceSetCurrentFocusedTask
		} = this.props

		if (forceSetCurrentFocusedTask) {
			forceSetCurrentFocusedTask(id)
		}
	}

	setSingleTaskVisible = () => {
		this.setState({
			isSingleVisibleInModal: true
		})
	}

	render() {
		const {
			elementHeight,
			isForcedFocus,
			isSingleVisibleInModal,
		} = this.state

		const {
			allTodoDays,
			allTodos,
			areEntitiesRecoverable,
			className,
			clearTaskActivityHistory,
			columns,
			currentFocusedTask,
			currentEditedTask,
			currentProject,
			editTaskName,
			hasAi,
			hasGantts,
			hasTiming,
			index,
			isPlanning,
			isCompact,
			isPremium,
			isProjectEditable,
			loading,
			menuState,
			milestone,
			milestoneIndex,
			normalisedApplicableUsers,
			openMenu,
			parentProject,
			shouldRender,
			setBrainData,
			statuses,
			task,
			taskActivityHistory,
			taskUpdateCallback,
			taskIndex,
			taskNameWidth,
			todoDays,
			isOptimistic,
			isActive
		} = this.props

		const isDisabled = !isProjectEditable || (task && task.isRecurredDuplicate)

		// 'windowing', kinda. performance thing.
		const showTask = shouldRender || loading

		const LoadingElement = !this.isMobile ? 'input' : 'textarea'

		let transitionContainerClassName = 'transition-container'

		if (currentFocusedTask === task.id || isForcedFocus) {
			transitionContainerClassName += ' focused'
		}

		if (showTask) {
			transitionContainerClassName += ' visible'
		}

		const statusId = getPrimaryColumnValue('status', task, currentProject)

		const canAddToToDo = (!isTaskInTodos(task, todoDays, allTodoDays, allTodos) && statusId !== 3)

		const mobileTaskButtons = [
			{
				icon: 'check-square-o',
				label: 'Add to to-do',
				disabled: !canAddToToDo,
				callback: this.addTaskToTodos
			}, {
				icon: 'fe-edit-2',
				label: 'Edit name',
				callback: this.editMobileTaskName
			}, {
				icon: 'fe-trash-2',
				label: 'Archive task',
				callback: this.deleteTask
			}
		]

		return (
			<React.Fragment>
				{isSingleVisibleInModal &&
					<SingleTaskPortal
						project={parentProject}
						applicableUsers={normalisedApplicableUsers}
						taskId={task.id}
						close={() => {
							this.setState({
								isSingleVisibleInModal: false
							})
						}}
					/>
				}
				<div
					className={transitionContainerClassName}
					ref={ref => this.ref = ref}
					data-milestone-index={milestoneIndex}
					style={!showTask ? {
						height: elementHeight + 'px'
					} : null}
				>
					{!showTask ?
						null
						:
						<React.Fragment>
							{(!milestoneIndex && !taskIndex) ?
								<Onboarder
									type='OPENED_TASK'
									direction="top-left"
									setFocus={isFocused => { this.forceSetCurrentFocusedTask(isFocused ? task.id : null) }}
								/>
								: null}
							<li className={`${className} ${loading ? 'loading' : ''} ${isActive ? 'active' : ''}`}>
								{
									loading ?
										<div className="task-name">
											<LoadingElement
												type="text"
												disabled={true}
												readOnly={true}
												className="task-random-name-string"
												style={{ animationDelay: index / 20 + 's' }}
												value={this.randomString}
											/>
										</div>
										:
										<TaskName
											currentProject={currentProject}
											parentProject={parentProject}
											width={taskNameWidth}
											currentEditedTask={currentEditedTask}
											editTaskName={editTaskName}
											task={task}
											milestone={milestone}
											isProjectEditable={!isDisabled}
											areEntitiesRecoverable={areEntitiesRecoverable}
											canAddToToDo={canAddToToDo}
											addTaskToTodos={this.addTaskToTodos}
											deleteTask={this.deleteTask}
											isPlanning={isPlanning}
											setSingleTaskVisible={this.setSingleTaskVisible}
										/>
								}
								{columns ? columns.map(_column => {
									const key = _column.type + '_' + _column.id

									if (!isPremium && !_column.is_primary) {
										return null
									}

									let column = null

									// For 'Capacity', as the milestone has mixed tasks in it.
									if (task.parentColumns && task.parentColumns.length && isPlanning) {
										column = task.parentColumns.find(parentColumn => {
											if (parentColumn) {
												return parentColumn.is_primary && parentColumn.type === _column.type
											}
										})

										if (!column) {
											column = _column
										}
									} else {
										column = _column
									}

									if (!column) {
										return null
									}

									const commonProps = {
										key,
										isDisabled,
										task: !loading ? task : null,
										openMenu,
										menuState,
										taskActivityHistory,
										clearTaskActivityHistory,
										milestone,
										column,
										currentProject,
										hasAi,
										setBrainData,
										hasGantts,
										taskUpdateCallback
									}

									switch (column.type) {
										case 'PEOPLE':
											return (
												<TaskPeople
													applicableUsers={normalisedApplicableUsers}
													{...commonProps}
												/>
											)
										case 'STATUS':
											return (
												<TaskStatus
													statuses={statuses}
													{...commonProps}
												/>
											)
										case 'DATE':
											return (
												<TaskDates
													{...commonProps}
													hasGantts={hasGantts && column.is_primary}
												/>
											)
										case 'TEXT':
										case 'LINK':
											return (
												<TaskText
													{...commonProps}
													isCompact={isCompact}
												/>
											)
										case 'PROJECT':
											return (
												<TaskProject
													{...commonProps}
													parentProject={parentProject}
												/>
											)
									}
								}) : null}
								{(!loading && hasTiming && isPremium && !isOptimistic) ?
									<React.Fragment>
										<TaskEstimate task={task} />
										{!isPlanning &&
											<TaskTimer task={task} />
										}
									</React.Fragment>
									: null}
								{this.isMobile ?
									<ul className="mobile-task-buttons">
										{mobileTaskButtons.map((button, index) => {
											return (
												<li key={index}>
													<button
														className={button.disabled ? 'disabled' : null}
														onClick={!button.disabled ? button.callback : null}
													>
														<Icon name={button.icon} />
														<span>
															{button.label}
														</span>
													</button>
												</li>
											)
										})}
									</ul>
									: null}
							</li>
						</React.Fragment>
					}
				</div>
			</React.Fragment>
		)
	}
}
const mapStateToProps = (state, props) => {
	return {
		todoDays: state.account.entities.users[state.account.entities.users[state.auth.userId].id].todo_days,
		allTodoDays: state.account.entities.todo_days,
		allTodos: state.account.entities.todos,
		parentProject: state.account.entities.projects[(props.task && props.task.project_id) ? props.task.project_id : null],
		normalisedApplicableUsers: (props.task && props.task.applicableUserIds) ? props.task.applicableUserIds.map(userId => state.account.entities.users[userId]) : props.applicableUsers,
		isActive: (state.account.currentTaskId && props.task && state.account.currentTaskId === props.task.id)
	}
}

export default connect(mapStateToProps, {
	createTodo,
	openModal,
})(Task)


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/task/task.jsx